import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { VariationAccountPage } from '@/features/commercial/variations-page';

const searchSchema = z.object({
  variation: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/commercial/variations')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <VariationAccountPage projectId={projectId} variation={search.variation} />;
}
